// Activity emojis mapping
export const ACTIVITY_EMOJIS: Record<string, string> = {
  'tennis': '🎾',
  'golf': '⛳',
  'swimming': '🏊‍♂️',
  'fitness': '💪',
  'yoga': '🧘‍♀️',
  'pilates': '🧘‍♂️',
  'football': '⚽',
  'padel': '🎾',
  'basketball': '🏀',
  'badminton': '🏸',
  'volleyball': '🏐',
  'table tennis': '🏓',
  'functional training': '🏋️',
  'boating': '🚢',
  'squash': '🎾',
  'scuba': '🤿',
  'running': '🏃‍♂️',
  'sauna': '💆‍♂️',
  'judo': '🥋',
  'basque pelota': '🥍',
  'windsurfing': '🌬️🏄‍♂️', 
  'cestoball': '⚽', 
  'hammam': '💆‍♂️',
  'hunting': '🏹',
  'fishing': '🎣',
  'mountaineering': ' 🧗',
  'field hockey': '🏑', 
  'cycling': '🚴‍♂️',
  'yachting': '🛥️',
  'gymnastics': '🤸',
  'gym': '🏋️‍♂️',
  'bowling':'🎳',
  'bowls': '🎳',
  'training': '💪',
  'martial arts': '🥋',
  'boxing': '🥊',
  'wellness': '🌿',
  'dance': '💃',
  'meditation': '🧘',
  'crossfit': '💪',
  'surfing': '🏄‍♂️',
  'pickleball': '🎾',
  'speedball': '🎾',
  'karate': '🥋',
  'Krav Maga': '🥋',
  'kong fu': '🥋',
  'taekwondo': '🥋',
  'aikido': '🥋',
  'horse riding': '🐎',
  'handball': '🤾', 
  'dancing': '💃', 
  'ballet': '🩰', 
  'synchronized swimming': '🏊‍♀️',  
  'polo': '🏇',
  'water polo': '🤽',
  'athletic': '🏃',
  'futsal': '⚽',
  'billiard': '🎱',
  'curling': '🥌',
  'billiards': '🎱',
  'sailing': '⛵',
  'diving': '🤿',
  'canoeing': '🚣‍♂️',
  'canoe': '🚣‍♂️',
  'snorkeling': '🤿',
  'parasailing': '🏄‍♂️',
  'five-a-side football': '⚽',
  '5-a-side football': '⚽',
  'rowing': '🚣‍♂️',
  'wakeboarding': '🏄‍♂️',
  'wakesurfing': '🏄‍♂️', 
  'pool': '🎱',
  'aerobics': '💃',
  'zumba': '💃',
  'equestrian': '🐎',
  'climbing': '🧗‍♂️',
  'aquatics': '🏊‍♂️',
  'cricket': '🏏',
  'hockey': '🏑',
  'spa': '💆‍♂️',
  'netball': '🏐',
  'rugby': '🏉',
  'softball': '🥎',
  'trekking': '🥾',
  'sea sports': '🛥️',
  'weight training': '🏋️‍♀️',
  'fencing': '🤺',
  'baseball': '⚾',
  'american football': '🏈',
  'athletics': '🏃',
  'skiing': '⛷️',
  'clay pigeon shooting': '🔫',
  'hiking': '🥾',
  'motorbiking': '🏍️',
  'spinning': '🚴‍♂️',
  'spin': '🚴‍♂️',
  'biking': '🚴‍♂️',
  'ski': '⛷️',
  'shooting': '🔫',
  'skating': '⛸️',
  'snowboarding': '🏂',
  'horse racing': '🏇'
} as const;